export const TWILIO_SENDGRID_LOGO = "https://uiux-assets.sendgrid.com/logo/sg-twilio-lockup.svg";
export const LOGO_ALT = "Twilio SendGrid Logo";
